import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Track from "@/pages/Track";
import Manage from "@/pages/Manage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FloatingContact from "@/components/FloatingContact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import Regions from "@/pages/Regions";
import RegionDetail from "@/pages/RegionDetail";
import Attractions from "@/pages/Attractions";
import AttractionDetail from "@/pages/AttractionDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import PopularRoutes from "@/pages/Routes";
import RouteDetail from "@/pages/RouteDetail";
import SeoLanding from "@/pages/SeoLanding";
import { SEO_LANGS } from "@/data/seoEngine";
import Prices from "@/pages/Prices";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import PaymentReturn from "@/pages/PaymentReturn";
import DriverPortal from "@/pages/DriverPortal";

function Layout({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const isHome = loc.pathname === "/";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [loc.pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      {!isAdmin && <Navbar />}
      <main className={`flex-1 ${!isAdmin && !isHome ? "pt-20" : ""} ${isAdmin ? "pt-0" : ""}`}>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingContact />}
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/book" element={<Booking />} />
              <Route path="/track" element={<Track />} />
              <Route path="/manage" element={<Manage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/:id" element={<DestinationDetail />} />
              <Route path="/regionen" element={<Regions />} />
              <Route path="/regionen/:slug" element={<RegionDetail />} />
              <Route path="/ausfluege" element={<Attractions />} />
              <Route path="/ausfluege/:slug" element={<AttractionDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/strecken" element={<PopularRoutes />} />
              <Route path="/strecken/:slug" element={<RouteDetail />} />
              <Route path="/preise" element={<Prices />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/booking/success" element={<PaymentReturn />} />
              <Route path="/driver/:token" element={<DriverPortal />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              {SEO_LANGS.filter((l) => l !== "de").map((l) => (
                <Route key={l} path={`/${l}/:seoSlug`} element={<SeoLanding pageLang={l} />} />
              ))}
              <Route path="/:seoSlug" element={<SeoLanding pageLang="de" />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
